var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-display"},[_c('img',{staticClass:"status-display__img",attrs:{"src":_vm.imgPath}}),_c('p',{staticClass:"font--m-3 mt-2 mb-0",domProps:{"innerHTML":_vm._s(_vm.showText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }